export const REGEX_NAME_VALIDATOR_PATTERN = /^[\p{L}\p{M}'\- ]+$/u;
export const REGEX_NAME_VALIDATOR_ERROR = 'Regular expression for name validations not set';
/**
 * Explanation of the Name Validation Regex Pattern:
 *
 * - `^`                   Start of the string.
 * - `[\p{L}\p{M}'\- ]+`   Match one or more characters within the defined character class.
 *   - `\p{L}`             Matches any Unicode letter character (covers letters from various languages).
 *   - `\p{M}`             Matches various diacritics (accents) that can appear in names.
 *   - `'`                 Allows apostrophes in names (e.g., O'Connor).
 *   - `\-`                Allows hyphens in names (e.g., Smith-Jones).
 *   - ` `                 Allows spaces in names.
 * - `$`                   End of the string.
 * - `u`                   Unicode flag for proper character handling.
 */
export class NameValidator {
    constructor(regex = REGEX_NAME_VALIDATOR_PATTERN) {
        this.regex = regex;
        if (!regex) {
            throw new Error(REGEX_NAME_VALIDATOR_ERROR);
        }
    }
    validate(name) {
        return this.regex.test(name);
    }
}
//# sourceMappingURL=NameValidator.js.map